import { render, staticRenderFns } from "./Poste.vue?vue&type=template&id=4d86fd40"
import script from "./Poste.vue?vue&type=script&lang=js"
export * from "./Poste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports